import React from "react";
import PageWrapper from "./category.style";
import PageTitle from "components/common/PageTitle";
import { connect } from "react-redux";
import CategoryTable from "../../components/category/CategoryTable";

const Category = props => {
  return (
    <PageWrapper {...props}>
      <PageTitle
        props={props}
        title="sidebar.category"
        className="plr-15"
        breadCrumb={[
          {
            name: "sidebar.dashboard",
            url: "/dashboard"
          },
          {
            name: "sidebar.category"
          }
        ]}
      />
      <div className="user-tbl">
        <CategoryTable {...props} />
      </div>
    </PageWrapper>
  );
};

const mapStateToProps = state => {
  return {
    ...state.permissionReducer,
    ...state.themeChanger,
    ...state.auth
  };
};

export default connect(mapStateToProps, null)(Category);
